// @flow

import type {TreeDataObj, TreeRowData} from '../typedef';

export const prepareTreeObj = <DataRow = {||}>(
    row: TreeRowData<DataRow>,
    topRow: TreeRowData<DataRow>
): TreeDataObj<Object> => {
    const {label, level, id, isTotal, expanded} = row;
    return {
        label,
        treeId: topRow.id,
        level,
        id,
        isTotal,
        expanded,
        isFlat: row.isFlat === undefined ? !!topRow.isFlat : row.isFlat,
        hideCheckbox: !(row.children && (row.children.length || 0))
    };
};

            // @pb/generate-flow-typed Webpack Loader:
            // Duplicates all internal dependencies imports
            // to be sure all deps are parsed by this loader
            // cause Babel loader removes `import type ...`
            // and e.g. 'typedef.js' files are not included in dist
            
require("../typedef");
